import React, { useState, useEffect } from "react";
import {
    Grid,
    TextField,
    MenuItem,
    Paper,
    Typography,
    Button,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    Box,
    Backdrop,
    CircularProgress,
    Divider,
    Chip,
    OutlinedInput,
    Select,
    FormControl,
    InputLabel,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import Cookies from "js-cookie";
import { useParams } from "react-router-dom";
import { url } from "../../../../../../../../../App";
import EditIcon from '@mui/icons-material/Edit';
import { useBorrowerContext } from "../../../../../../store/borrower-details";
import VisibilityIcon from '@mui/icons-material/Visibility';
import { Tooltip } from "@mui/material";
// List of available crop types
const CROP_OPTIONS = ["Wheat", "Rice", "Maize", "Barley", "Soybean", "Cotton",
    "Sugarcane", "Potato", "Tomato", "Onion", "Sunflower", "Sorghum", "Groundnut", "Mustard", "Castor", "Cumin", "Carom Seeds"];
function CropsModal({ open, onClose, row }) {
    return (
        <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
            <DialogTitle>
                <Typography variant="h6">
                    Crops Details
                </Typography>
            </DialogTitle>
            <DialogContent dividers>
                {row?.crops && row?.crops?.length > 0 ? (
                    <Box>
                        <Table size="small" sx={{ borderCollapse: 'collapse', width: '100%' }}>
                            <TableHead>
                                <TableRow sx={{ backgroundColor: '#e3f2fd' }}>
                                    <TableCell sx={{ border: '1px solid black', fontWeight: 'bold' }}>Crop Name</TableCell>
                                    <TableCell sx={{ border: '1px solid black', fontWeight: 'bold' }}>Gross Income</TableCell>
                                    <TableCell sx={{ border: '1px solid black', fontWeight: 'bold' }}>Expense</TableCell>
                                    <TableCell sx={{ border: '1px solid black', fontWeight: 'bold' }}>Net Income</TableCell>
                                    <TableCell sx={{ border: '1px solid black', fontWeight: 'bold' }}>Monthly Income</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {row?.crops?.map((crop, idx) => (
                                    <TableRow key={idx}>
                                        <TableCell sx={{ border: '1px solid black' }}>{crop?.cropName || ""}</TableCell>
                                        <TableCell sx={{ border: '1px solid black' }}>{crop?.grossIncome || "0"}</TableCell>
                                        <TableCell sx={{ border: '1px solid black' }}>{crop?.expense || "0"}</TableCell>
                                        <TableCell sx={{ border: '1px solid black' }}>{crop?.netIncome?.toFixed(2) || "0"}</TableCell>
                                        <TableCell sx={{ border: '1px solid black' }}>{crop?.monthlyIncome?.toFixed(2) || "0"}</TableCell>
                                    </TableRow>
                                ))}
                                <TableRow sx={{ backgroundColor: 'rgb(226, 240, 217)' }}>
                                    <TableCell sx={{ border: '1px solid black', fontWeight: 'bold' }}>Total</TableCell>
                                    <TableCell sx={{ border: '1px solid black', fontWeight: 'bold' }}>
                                        {row?.crops?.reduce((sum, crop) => sum + (Number(crop?.grossIncome) || 0), 0)?.toFixed(2)}
                                    </TableCell>
                                    <TableCell sx={{ border: '1px solid black', fontWeight: 'bold' }}>
                                        {row?.crops?.reduce((sum, crop) => sum + (Number(crop?.expense) || 0), 0)?.toFixed(2)}
                                    </TableCell>
                                    <TableCell sx={{ border: '1px solid black', fontWeight: 'bold' }}>
                                        {row?.crops?.reduce((sum, crop) => sum + (Number(crop?.netIncome) || 0), 0)?.toFixed(2)}
                                    </TableCell>
                                    <TableCell sx={{ border: '1px solid black', fontWeight: 'bold' }}>
                                        {row?.crops?.reduce((sum, crop) => sum + (Number(crop?.monthlyIncome) || 0), 0)?.toFixed(2)}
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </Box>
                ) : (
                    <Typography>No crops data available</Typography>
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="primary">
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    );
}
const SecondaryIncome = () => {
    const { loanid } = useParams();
    const mappedLoanId = loanid;
    const token = Cookies.get("Token");
    const email = Cookies.get("Email");
    const [open, setOpen] = useState(false);
    const [currentEntry, setcurrentEntry] = useState(null);
    const { borrowerData } = useBorrowerContext();
    const fetchLoanDetails = borrowerData.loan;
    const foundLoan = fetchLoanDetails.find((item) => item.loan_id === mappedLoanId);
    const [isDisbursed, setIsDisbursed] = useState(false);
    const [openCroptype, setopenCroptype] = useState(false);
    const [modalOpen, setModalOpen] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);
    const [visible, setvisible] = useState(false);
    const [addSecondary, setAddSecondary] = useState(false);
    const [deleteSecondary, setDeleteSecondary] = useState(false);
    const [editSecondary, setEditSecondary] = useState(false);

    useEffect(() => {

        if (email === "rupesh.bishnoi@credin.in") {
            setvisible(true);
            setAddSecondary(true);
            setDeleteSecondary(true);
            setEditSecondary(true);
        } else {
            axios
                .post(url + "/user/getsingle", {
                    token: token,
                    email: email,
                    useremail: email,
                })
                .then((res) => {
                    setAddSecondary(res.data[0]?.permission.add_secondary_cam);
                    setDeleteSecondary(res.data[0]?.permission.delete_secondary_cam);
                    setEditSecondary(res.data[0]?.permission.edit_secondary_cam);
                })
                .catch((err) => {
                    console.log(err);
                });
        }


    }, [email, token]);

    const handleOpenModal = (row) => {
        setSelectedRow(row);
        setModalOpen(true);
    };

    const handleCloseModal = () => {
        setModalOpen(false);
        setSelectedRow(null);
    };
    useEffect(() => {
        console.log("loan id=> ", loanid)
        if (mappedLoanId) {
            setIsDisbursed(foundLoan?.loan_status === "DISBURSED");
        }
        //eslint-disable-next-line
    }, [foundLoan]);

    const [secondaryIncomeDetails, setSecondaryIncomeDetails] = useState({
        incomeType: "",
        amount: "",
        incomeSource: "",
        incomeMode: "",
        margin: 0,
        finalIncome: "",
        relationshipWithApplicant: "",
        earningMemeberName: "",
    });

    const [rows, setRows] = useState([]);

    // Agriculture state
    const [agriculture, setAgriculture] = useState({
        ownedLand: "",
        totalLandHolders: "1",
        borrowerOwnedLand: "",
        rentedLand: "",
        cultivationLand: "",
        irrigationStatus: "",
        numberOfCrops: "",
        margin: 0
    });

    const [crops, setCrops] = useState(
        Array.from({ length: 12 }, (_, i) => ({
            name: `Crop ${i + 1}`,
            grossIncome: "",
            expense: "",
            netIncome: "",
            monthlyIncome: ""
        }))
    );
    // useEffect(() => {
    // }, [crops, agriculture])
    // New state for multi-select crop types
    const [selectedCropTypes, setSelectedCropTypes] = useState([]);
    // State for dynamic crop rows based on selectedCropTypes
    const [cropRows, setCropRows] = useState([]);
    const [updateandSubmitbtn, setupdateandSubmitbtn] = useState("SUBMIT")
    // Handle input change
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setSecondaryIncomeDetails((prev) => ({ ...prev, [name]: value }));
    };
    // Handle multi-select crop types change with validation
    const handleCropTypeChange = (event) => {
        const value = event.target.value;
        // Ensure value is always an array when multiple is true
        const selectedValues = Array.isArray(value) ? value : (value ? [value] : []);
        const maxCrops = parseInt(agriculture?.numberOfCrops) || 0;

        if (selectedValues.length === maxCrops) {
            setopenCroptype(false);
        }

        // Check if user is trying to select more crops than allowed
        if (selectedValues.length > maxCrops) {
            toast.error(`You can only select up to ${maxCrops} crop types based on your "Number of Crops" selection.`);
            return; // Prevent selection
        }

        setSelectedCropTypes(selectedValues);
    };

    // Update cropRows whenever selectedCropTypes changes
    useEffect(() => {
        if (selectedCropTypes && selectedCropTypes.length > 0) {
            const newCropRows = selectedCropTypes.map((cropName) => {
                // Preserve existing data if already present
                const existing = cropRows.find(row => row?.cropName === cropName);

                return existing || {
                    cropName: cropName,
                    grossIncome: "",
                    expense: "",
                    netIncome: 0,
                    monthlyIncome: 0
                };
            });

            setCropRows(newCropRows);
        } else {
            setCropRows([]);
        }
        // eslint-disable-next-line
    }, [selectedCropTypes]);
    useEffect(() => {
    }, [agriculture?.numberOfCrops, cropRows, selectedCropTypes])

    // Calculate net income and monthly income for a crop row
    const calculateCropTotals = (grossIncome, expense) => {
        const gross = Number(grossIncome) || 0;
        const exp = Number(expense) || 0;
        const net = gross - exp;
        const monthly = net / 12;
        return { net, monthly };
    };

    // Handle crop row field change
    const handleCropRowChange = (index, field, value) => {
        // Prevent negative values
        if (value < 0) return;

        const updated = [...cropRows];
        updated[index][field] = value;

        const { net, monthly } = calculateCropTotals(
            updated[index].grossIncome,
            updated[index].expense
        );
        updated[index].netIncome = net;
        updated[index].monthlyIncome = monthly;

        setCropRows(updated);
    };

    // Calculate totals for crop rows - ensure numeric values
    const totalGrossIncome = cropRows?.reduce((sum, row) => sum + (Number(row.grossIncome) || 0), 0);
    const totalExpense = cropRows?.reduce((sum, row) => sum + (Number(row.expense) || 0), 0);
    const totalNetIncome = cropRows?.reduce((sum, row) => sum + (Number(row.netIncome) || 0), 0);
    const totalMonthlyIncome = cropRows?.reduce((sum, row) => sum + (Number(row.monthlyIncome) || 0), 0);

    // Borrower owned / cultivation calculation
    useEffect(() => {
        const borrowerOwned =
            agriculture?.ownedLand && agriculture?.totalLandHolders
                ? agriculture?.ownedLand / agriculture?.totalLandHolders
                : 0;
        const cultivation = Number(borrowerOwned) + Number(agriculture?.rentedLand || 0);

        setAgriculture((prev) => ({
            ...prev,
            borrowerOwnedLand: borrowerOwned?.toFixed(2),
            cultivationLand: cultivation?.toFixed(2)
        }));
    }, [agriculture?.ownedLand, agriculture?.totalLandHolders, agriculture?.rentedLand]);
    useEffect(() => {
        if (agriculture?.totalLandHolders === "0" || agriculture?.ownedLand === "0") {
            setAgriculture((prev) => ({
                ownedLand: "1",
                totalLandHolders: "1",
                borrowerOwnedLand: prev?.borrowerOwnedLand,
                rentedLand: prev?.rentedLand,
                cultivationLand: prev?.cultivationLand,
                irrigationStatus: prev?.irrigationStatus,
                numberOfCrops: prev?.numberOfCrops,
                margin: 0
            }));
            toast.error("Total Land Holders and Owned Land can not be zero or empty !")
        }
    }, [agriculture.totalLandHolders, agriculture.ownedLand])

    // Crop calculations for old crops (if needed)
    const handleCropChange = (index, field, value) => {
        const updated = [...crops];
        updated[index][field] = value;
        const gross = Number(updated[index].grossIncome || 0);
        const expense = Number(updated[index].expense || 0);
        updated[index].netIncome = gross - expense;
        updated[index].monthlyIncome = ((gross - expense) / 12).toFixed(2);
        setCrops(updated);
    };
    const visibleCrops = crops?.slice(0, Number(agriculture.numberOfCrops));

    const totalGross = visibleCrops?.reduce(
        (sum, c) => sum + Number(c?.grossIncome || 0),
        0
    );

    const totalExpenseOld = visibleCrops?.reduce(
        (sum, c) => sum + Number(c?.expense || 0),
        0
    );

    const totalNet = visibleCrops?.reduce(
        (sum, c) => sum + Number(c?.netIncome || 0),
        0
    );

    const totalMonthly = visibleCrops?.reduce(
        (sum, c) => sum + Number(c?.monthlyIncome || 0),
        0
    );

    // Final income calculation
    useEffect(() => {
        const calculatedFinalIncome =
            secondaryIncomeDetails?.amount && secondaryIncomeDetails?.margin
                ? (secondaryIncomeDetails?.amount * secondaryIncomeDetails?.margin) / 100
                : 0;
        setSecondaryIncomeDetails((prev) => ({
            ...prev,
            finalIncome: calculatedFinalIncome?.toFixed(2)
        }));
    }, [secondaryIncomeDetails?.amount, secondaryIncomeDetails?.margin]);


    // Fetch existing secondary income
    useEffect(() => {
        if (mappedLoanId) {
            setOpen(true);
            axios
                .post(`${url}/cam/get/cam/data`, { token, email, loanId: mappedLoanId })
                .then((res) => setRows(res?.data?.borrowerSecondaryIncome))
                .catch(() => toast.error("Failed to fetch secondary income"))
                .finally(() => setOpen(false));
        }
        console.log("secondary income", secondaryIncomeDetails)
        // eslint-disable-next-line 
    }, [mappedLoanId]);


    // Submit secondary income
    const handleAddData = async (e) => {
        e.preventDefault();
        setOpen(true);
        if (updateandSubmitbtn === "UPDATE") {
            if (secondaryIncomeDetails?.incomeType === "Agriculture") {
                if (selectedCropTypes?.length === 0) {
                    toast.error("Please select the crops name !");
                    setOpen(false);
                    return;
                }
                const cropsData = cropRows.map(row => ({
                    cropName: row?.cropName,
                    grossIncome: row?.grossIncome,
                    expense: row?.expense,
                    netIncome: row?.netIncome,
                    monthlyIncome: row?.monthlyIncome
                }));
                console.log("currentEntry=> ", currentEntry)

                const payload = {
                    token,
                    email,
                    loanId: mappedLoanId,
                    incomeId: currentEntry?._id || currentEntry.id || currentEntry.incomeId,
                    incomeType: "Agriculture",
                    crops: cropsData,
                    incomeMode: secondaryIncomeDetails?.incomeMode,
                    incomeSource: secondaryIncomeDetails?.incomeSource,
                    amount: parseFloat(totalMonthlyIncome).toFixed(2),
                    relationshipWithApplicant: secondaryIncomeDetails?.relationshipWithApplicant,
                    earningMemeberName: secondaryIncomeDetails?.earningMemeberName,
                    finalIncome: (
                        (Number(agriculture?.margin) || 0) *
                        (Number(totalMonthlyIncome) || 0) / 100
                    ).toFixed(2),
                    ...agriculture,


                }
                if (payload?.numberOfCrops !== payload?.crops?.length) {
                    toast.error("The number of crops should be equal to number of crop select in crop type ! ")
                    setOpen(false);
                    return;
                }
                const response = await axios.put(`${url}/cam/update/secondary-income`, payload);
                console.log("res secondary  => ", response)
                if (response?.data?.auth === false) {
                    if (response?.data?.logout) {
                        setTimeout(() => {
                            window.location.href = "/";
                        }, 300);
                    }
                    else {
                        toast.error(response?.data?.message)
                        setOpen(false);
                        return;
                    }
                }
                setRows(response?.data?.updatedIncome);
                setOpen(false);
                setSecondaryIncomeDetails((prv) => ({
                    incomeType: "",
                    amount: "",
                    incomeSource: "",
                    incomeMode: "",
                    margin: 0,
                    finalIncome: "",
                    earningMemeberName: "",
                    relationshipWithApplicant: ""
                }));
                setAgriculture({
                    ownedLand: "",
                    totalLandHolders: "1",
                    borrowerOwnedLand: "",
                    rentedLand: "",
                    cultivationLand: "",
                    irrigationStatus: "",
                    numberOfCrops: "",
                    margin: 0
                });
                setupdateandSubmitbtn("SUBMIT");
                toast.success("Update successfully");
                return;
            }
            try {
                console.log("        loanId:loanid-> ", loanid)
                console.log("secondaryIncomeDetails-> ", secondaryIncomeDetails)
                const response = await axios.put(`${url}/cam/update/secondary-income`,
                    { ...secondaryIncomeDetails, incomeId: currentEntry?._id || currentEntry?.id || currentEntry.incomeId, loanId: currentEntry?.loanId || loanid, token, email }
                );
                console.log("res secondary  => ", response)
                if (response?.data?.auth === false) {
                    if (response?.data?.logout) {
                        setTimeout(() => {
                            window.location.href = "/";
                        }, 300);
                    }
                    else {
                        setOpen(false);
                        toast.error(response?.data?.message)
                        return;
                    }
                }
                setRows(response?.data?.updatedIncome);
                setOpen(false);
                setSecondaryIncomeDetails((prv) => ({
                    incomeType: "",
                    amount: "",
                    incomeSource: "",
                    incomeMode: "",
                    margin: 0,
                    finalIncome: "",
                    earningMemeberName: "",
                    relationshipWithApplicant: ""
                }));
                setAgriculture({
                    ownedLand: "",
                    totalLandHolders: "1",
                    borrowerOwnedLand: "",
                    rentedLand: "",
                    cultivationLand: "",
                    irrigationStatus: "",
                    numberOfCrops: "",
                    margin: 0
                })
                toast.success("Update successfully");

            } catch {
                setOpen(false);
                toast.error("Failed to update");
            }
            setupdateandSubmitbtn("SUBMIT");
            return;
        }

        try {
            let payload = {}
            if (secondaryIncomeDetails?.incomeType === "Agriculture") {
                if (selectedCropTypes?.length === 0) {
                    toast.error("Please select the crops name !");
                    setOpen(false);
                    return;
                }
                // if (secondaryIncomeDetails?.numberOfCrops !== secondaryIncomeDetails?.crops?.length) {
                //     toast.error("The number of crops should be equal to number of crop select in crop type ! ")
                //     setOpen(false);
                //     return;
                // }
                console.log("totalNet is ===> ", parseFloat(totalNet).toFixed(2));

                // Create crops data from cropRows instead of old crops state
                const cropsData = cropRows.map(row => ({
                    cropName: row?.cropName,
                    grossIncome: row?.grossIncome,
                    expense: row?.expense,
                    netIncome: row?.netIncome,
                    monthlyIncome: row?.monthlyIncome
                }));
                payload = {
                    token,
                    email,
                    loanId: mappedLoanId,
                    incomeId: currentEntry?._id,
                    amount: parseFloat(totalMonthlyIncome)?.toFixed(2),
                    margin: parseFloat(agriculture?.margin),
                    incomeType: "Agriculture",
                    crops: cropsData,
                    incomeMode: secondaryIncomeDetails?.incomeMode,
                    incomeSource: secondaryIncomeDetails?.incomeSource,
                    earningMemeberName: secondaryIncomeDetails?.earningMemeberName,
                    relationshipWithApplicant: secondaryIncomeDetails?.relationshipWithApplicant,
                    finalIncome: (
                        (Number(agriculture?.margin) || 0) *
                        (Number(totalMonthlyIncome) || 0) / 100
                    ).toFixed(2),
                    ...agriculture,
                    // ...secondaryIncomeDetails,
                }
            }
            else {

                payload = {
                    token,
                    email,
                    loanId: mappedLoanId,
                    amount: parseFloat(secondaryIncomeDetails?.amount)?.toFixed(2),
                    margin: parseFloat(secondaryIncomeDetails?.margin)?.toFixed(2),
                    finalIncome: parseFloat(secondaryIncomeDetails?.finalIncome)?.toFixed(2),
                    ...secondaryIncomeDetails,
                }
            }
            if (payload?.numberOfCrops !== payload?.crops?.length) {
                toast.error("The number of crops should be equal to number of crop select in crop type ! ")
                setOpen(false);
                return;
            }
            const response = await axios.post(`${url}/cam/add/secondary-income`, payload);
            console.log("response-> ", response)
            if (response?.data?.auth === false) {
                toast.error(response?.data?.message);
                return;
            }
            toast.success("Secondary income submitted successfully");
            setRows(response?.data?.data?.borrowerSecondaryIncome);
            setSecondaryIncomeDetails((prv) => ({
                incomeType: "",
                amount: "",
                incomeSource: "",
                incomeMode: "",
                margin: 0,
                finalIncome: "",
                earningMemeberName: "",
                relationshipWithApplicant: ""
            }));
            setAgriculture({
                ownedLand: "",
                totalLandHolders: "1",
                borrowerOwnedLand: "",
                rentedLand: "",
                cultivationLand: "",
                irrigationStatus: "",
                numberOfCrops: "",
                margin: 0
            });
            // Reset crop selection
            setSelectedCropTypes([]);
            setCropRows([]);
        } catch (error) {
            console.log("error-> ", error);
            toast.error("Failed to submit");
        } finally {
            setOpen(false);
        }
    };

    // Delete income
    const deleteSecondaryIncome = async (id) => {
        console.log("id-> ", id)
        if (updateandSubmitbtn === "UPDATE") return;
        try {
            const response = await axios.delete(`${url}/cam/delete/secondary-income`, {
                data: { loanId: mappedLoanId, incomeId: id, email, token }
            });
            setRows(response?.data?.updatedIncome);
            setSecondaryIncomeDetails((prv) => ({
                incomeType: "",
                amount: "",
                incomeSource: "",
                incomeMode: "",
                margin: 0,
                finalIncome: "",
                earningMemeberName: "",
                relationshipWithApplicant: ""
            }));
            setAgriculture({
                ownedLand: "",
                totalLandHolders: "1",
                borrowerOwnedLand: "",
                rentedLand: "",
                cultivationLand: "",
                irrigationStatus: "",
                numberOfCrops: "",
                margin: 0
            });
            toast.success("Deleted successfully");

        } catch (err) {
            console.log("error-> ", err)
            toast.error("Failed to delete");
        }
    };
    const handleUpdateData = async (entry) => {
        setupdateandSubmitbtn("UPDATE")
        console.log("Agriculture Entry=> ", entry)
        setcurrentEntry(entry)
        if (entry.incomeType === "Agriculture") {
            setAgriculture({
                ownedLand: entry?.ownedLand || "",
                totalLandHolders: entry?.totalLandHolders || "",
                borrowerOwnedLand: entry?.borrowerOwnedLand || "",
                rentedLand: entry?.rentedLand || "",
                cultivationLand: entry?.cultivationLand || "",
                irrigationStatus: entry?.irrigationStatus || "",
                numberOfCrops: entry?.numberOfCrops || "",
                margin: entry?.margin || "",
                incomeId: entry?.id || entry?._id || entry.incomeId
            })
            setCropRows(entry?.crops)
            // console.log("crops name ", entry?.crops?.map(value => value?.cropName))
            const cropNames = entry?.crops?.map(value => value?.cropName) || [];
            setSelectedCropTypes(cropNames);
        }
        setSecondaryIncomeDetails({
            incomeType: entry?.incomeType === "Business Income" ? "Business" : entry?.incomeType,
            amount: entry?.amount,
            incomeSource: entry?.incomeSource,
            incomeMode: entry?.incomeMode,
            margin: entry?.margin,
            finalIncome: entry?.finalIncome,
            relationshipWithApplicant: entry?.relationshipWithApplicant === "self" ? "Self" : entry?.relationshipWithApplicant,
            earningMemeberName: entry?.earningMemeberName,
            incomeId: entry?.id || entry?._id || entry?.incomeId
        })
    }
    useEffect(() => {
        if (updateandSubmitbtn === "UPDATE") {
            console.log("current=> ", currentEntry?.incomeType, "preve=> ", secondaryIncomeDetails?.incomeType)
            if ((currentEntry?.incomeType === "Salary" || currentEntry?.incomeType === "Business") && (secondaryIncomeDetails?.incomeType === "Agriculture")) {
                toast.error("Salary and Business income can not change into Agriculture income !");
                setSecondaryIncomeDetails((prev) => ({
                    incomeType: currentEntry?.incomeType === "Salary" ? "Salary" : "Business",
                    amount: prev?.amount,
                    incomeSource: prev?.incomeSource,
                    incomeMode: prev?.incomeMode,
                    margin: prev?.margin,
                    finalIncome: prev?.finalIncome,
                    relationshipWithApplicant: prev?.relationshipWithApplicant,
                    earningMemeberName: prev?.earningMemeberName
                }))
                return;
            }
            if ((currentEntry?.incomeType === "Agriculture") && (secondaryIncomeDetails?.incomeType === "Salary" || secondaryIncomeDetails?.incomeType === "Business")) {
                toast.error("Agriculture income can not change into Salary and Business income !");
                setSecondaryIncomeDetails((prev) => ({
                    incomeType: "Agriculture",
                    amount: prev?.amount,
                    incomeSource: prev?.incomeSource,
                    incomeMode: prev?.incomeMode,
                    margin: prev?.margin,
                    finalIncome: prev?.finalIncome,
                    relationshipWithApplicant: prev?.relationshipWithApplicant,
                    earningMemeberName: prev?.earningMemeberName
                }))
                return;
            }
        }
    }, [secondaryIncomeDetails?.incomeType, agriculture?.incomeType, updateandSubmitbtn, currentEntry?.incomeType])
    useEffect(() => {
        if (secondaryIncomeDetails?.relationshipWithApplicant === "Self" || secondaryIncomeDetails?.relationshipWithApplicant === "self") {
            console.log("borrowerData-> ", borrowerData);
            const fullName = `${borrowerData?.borrower?.borrower_firstname || ''} ${borrowerData?.borrower?.borrower_lastname || ''}`.trim();
            console.log("Setting earning member name to:", fullName);
            setSecondaryIncomeDetails((prev) => ({
                ...prev,
                earningMemeberName: fullName
            }));
        }
        else {
            setSecondaryIncomeDetails((prev) => ({
                ...prev,
                earningMemeberName: ""
            }));
        }
    }, [secondaryIncomeDetails?.relationshipWithApplicant, borrowerData]);

    useEffect(() => {
        if (secondaryIncomeDetails?.incomeType === "Agriculture") {
            setSecondaryIncomeDetails(prev => ({
                ...prev,
                incomeSource: "Agriculture"
            }));
        }
    }, [secondaryIncomeDetails?.incomeType]);
    return (
        <Box p={3}>
            <h3 style={{ fontWeight: 'bold', textAlign: 'center', fontSize: '1.2rem' }}>
                Secondary Income
            </h3>
            <Paper elevation={3} sx={{ p: 3, mb: 3 }}>
                <div container spacing={2} >
                    <div item xs={12} md={4}>
                        <TextField
                            select
                            sx={{ width: '30rem' }}
                            label="Income Type"
                            name="incomeType"
                            value={secondaryIncomeDetails.incomeType}
                            onChange={handleInputChange}
                            disabled={isDisbursed}
                        >
                            <MenuItem value="">Select</MenuItem>
                            <MenuItem value="Salary">Salary</MenuItem>
                            <MenuItem value="Agriculture">Agriculture</MenuItem>
                            <MenuItem value="Business">Business</MenuItem>
                        </TextField>
                    </div>
                    {(secondaryIncomeDetails?.incomeType) && (
                        <div style={{ display: 'flex', gap: '10px', marginTop: '10px', flexWrap: 'wrap' }}>

                            <div item xs={12} md={4}>
                                <TextField
                                    label="Relationship with Applicant"
                                    name="relationshipWithApplicant"
                                    sx={{ width: '20rem' }}
                                    value={secondaryIncomeDetails?.relationshipWithApplicant}
                                    onChange={handleInputChange}
                                    onKeyDown={(e) => {
                                        if (!/[a-zA-Z\s]/.test(e.key) && e.key !== "Backspace") {
                                            e.preventDefault();
                                        }
                                    }}
                                    disabled={isDisbursed}
                                    select
                                >
                                    <MenuItem value="">Select </MenuItem>
                                    <MenuItem value="Self">Self</MenuItem>
                                    <MenuItem value="Brother">Brother</MenuItem>
                                    <MenuItem value="Sister">Sister</MenuItem>
                                    <MenuItem value="Father">Father</MenuItem>
                                    <MenuItem value="Mother">Mother</MenuItem>
                                    <MenuItem value="Son">Son</MenuItem>
                                    <MenuItem value="Daughter">Daughter</MenuItem>
                                    <MenuItem value="Spouse">Spouse</MenuItem>
                                    <MenuItem value="friend">Friend</MenuItem>

                                </TextField>

                            </div>
                            <div item xs={12} md={4}>
                                <TextField
                                    label="Earning Member Name"
                                    sx={{ width: '20rem' }}
                                    type="text"
                                    name="earningMemeberName"
                                    value={secondaryIncomeDetails?.earningMemeberName}
                                    disabled={
                                        secondaryIncomeDetails?.relationshipWithApplicant === "Self" || isDisbursed
                                    }
                                    onChange={handleInputChange}
                                    onKeyDown={(e) => {
                                        if (!/[a-zA-Z\s]/.test(e.key) && e.key !== "Backspace") {
                                            e.preventDefault();
                                        }
                                    }}

                                />
                            </div>



                            <div item xs={12} md={4}>
                                <TextField
                                    select
                                    label="Income Mode"
                                    name="incomeMode"
                                    sx={{ width: '20rem' }}
                                    value={secondaryIncomeDetails?.incomeMode}
                                    onChange={handleInputChange}
                                    disabled={isDisbursed}
                                >
                                    <MenuItem value="">Select Mode</MenuItem>
                                    <MenuItem value="Cash">Cash</MenuItem>
                                    <MenuItem value="Bank">Bank</MenuItem>
                                </TextField>
                            </div>

                            <div item xs={12} md={4}>
                                <TextField
                                    label="Income Source Name"
                                    name="incomeSource"
                                    sx={{ width: '20rem' }}
                                    value={secondaryIncomeDetails?.incomeSource}
                                    onChange={handleInputChange}
                                    onKeyDown={(e) => {
                                        if (!/[a-zA-Z\s]/.test(e.key) && e.key !== "Backspace") {
                                            e.preventDefault();
                                        }
                                    }}
                                    disabled={isDisbursed || secondaryIncomeDetails?.incomeType === "Agriculture"}
                                />
                            </div>


                            <div item xs={12} md={4}>
                                {((secondaryIncomeDetails?.incomeType !== "Agriculture") && (<TextField
                                    label="Amount per Month"
                                    type="number"
                                    sx={{ width: '20rem' }}
                                    name="amount"
                                    value={secondaryIncomeDetails?.amount}
                                    onChange={handleInputChange}
                                    inputProps={{ min: 0 }}
                                    onKeyDown={(e) => {
                                        if (e.key === '-' || e.key === 'e') {
                                            e.preventDefault();
                                        }
                                    }}
                                    disabled={isDisbursed}
                                />))}
                            </div>
                            <div item xs={12} md={4}>
                                {((secondaryIncomeDetails.incomeType !== "Agriculture") && (<TextField
                                    label="Margin (%)"
                                    type="number"
                                    name="margin"
                                    sx={{ width: '20rem' }}
                                    value={secondaryIncomeDetails?.margin}
                                    onChange={handleInputChange}
                                    inputProps={{ min: 0, max: 100 }}
                                    onKeyDown={(e) => {
                                        if (e.key === '-' || e.key === 'e') {
                                            e.preventDefault();
                                        }
                                    }}
                                    disabled={isDisbursed}
                                />))}
                            </div>

                            <div item xs={12} md={4}>
                                {((secondaryIncomeDetails?.incomeType !== "Agriculture") && (<TextField
                                    sx={{ width: '20rem' }}
                                    label="Income Consideration per Month"
                                    value={secondaryIncomeDetails?.finalIncome}
                                    disabled
                                />))}
                            </div>
                        </div>
                    )}
                </div>

                {/* AGRICULTURE SECTION */}
                {secondaryIncomeDetails?.incomeType === "Agriculture" && (
                    <>
                        <Divider sx={{ my: 3 }} />
                        <h3 style={{ fontWeight: 'bold', textAlign: 'center', fontSize: '1.2rem', marginBottom: '10px' }}>
                            Agriculture Details
                        </h3>
                        <div container spacing={2} style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
                            <div item xs={12} md={4}>
                                <TextField
                                    required
                                    label="Owned Land (Hectare)"
                                    type="number"
                                    sx={{ width: '20rem' }}
                                    value={agriculture.ownedLand}
                                    onChange={(e) =>
                                        setAgriculture({ ...agriculture, ownedLand: e.target.value })
                                    }
                                    inputProps={{ min: 0 }}
                                    onKeyDown={(e) => {
                                        if (e.key === '-' || e.key === 'e') {
                                            e.preventDefault();
                                        }
                                    }}
                                    disabled={isDisbursed}
                                />
                            </div>
                            <div item xs={12} md={4}>
                                <TextField
                                    required
                                    label="Total Land Holders"
                                    type="number"
                                    sx={{ width: '20rem' }}
                                    value={agriculture?.totalLandHolders}
                                    onChange={(e) =>
                                        setAgriculture({ ...agriculture, totalLandHolders: e.target.value })
                                    }
                                    inputProps={{ min: 1 }}
                                    onKeyDown={(e) => {
                                        if (e.key === '-' || e.key === 'e') {
                                            e.preventDefault();
                                        }
                                    }}
                                    disabled={isDisbursed}
                                />
                            </div>
                            <div item xs={12} md={4}>
                                <TextField
                                    label="Borrower Owned Land"
                                    sx={{ width: '20rem' }}
                                    value={agriculture?.borrowerOwnedLand}
                                    disabled
                                />
                            </div>
                            <div item xs={12} md={4}>
                                <TextField
                                    label="Rented Land"
                                    type="number"
                                    sx={{ width: '20rem' }}
                                    value={agriculture?.rentedLand}
                                    onChange={(e) =>
                                        setAgriculture({ ...agriculture, rentedLand: e.target.value })
                                    }
                                    inputProps={{ min: 0 }}
                                    onKeyDown={(e) => {
                                        if (e.key === '-' || e.key === 'e') {
                                            e.preventDefault();
                                        }
                                    }}
                                    disabled={isDisbursed}
                                />
                            </div>
                            <div item xs={12} md={4}>
                                <TextField
                                    label="Cultivation Land"
                                    sx={{ width: '20rem' }}
                                    value={agriculture?.cultivationLand}
                                    disabled
                                />
                            </div>
                            <div item xs={12} md={4}>
                                <TextField
                                    select
                                    sx={{ width: '20rem' }}
                                    label="Irrigation Status"
                                    value={agriculture?.irrigationStatus}
                                    onChange={(e) =>
                                        setAgriculture({ ...agriculture, irrigationStatus: e.target.value })
                                    }
                                    disabled={isDisbursed}
                                >
                                    <MenuItem value="">Select</MenuItem>
                                    <MenuItem value="Yes">Yes</MenuItem>
                                    <MenuItem value="No">No</MenuItem>
                                </TextField>
                            </div>

                            <div item xs={12} md={4}>
                                <TextField
                                    select
                                    sx={{ width: '20rem' }}
                                    label="Number of Crops/Year"
                                    value={agriculture?.numberOfCrops}
                                    onChange={(e) =>
                                        setAgriculture({ ...agriculture, numberOfCrops: e.target.value })
                                    }
                                    disabled={isDisbursed}
                                >
                                    {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((n) => (
                                        <MenuItem key={n} value={n}>
                                            {n}
                                        </MenuItem>
                                    ))}
                                </TextField>
                            </div>
                        </div>

                        {/* Multi-Select Crop Types Dropdown */}
                        {agriculture?.numberOfCrops && (
                            <Box sx={{ mt: 3 }}>
                                <FormControl fullWidth>
                                    <InputLabel>Crop Types</InputLabel>
                                    <Select
                                        multiple
                                        open={openCroptype}
                                        onOpen={() => setopenCroptype(true)}
                                        onClose={() => setopenCroptype(false)}
                                        sx={{ width: '20rem', height: 'auto', minHeight: "35px" }}
                                        value={Array.isArray(selectedCropTypes) ? selectedCropTypes : []}
                                        onChange={handleCropTypeChange}
                                        input={<OutlinedInput label="Crop Types" />}
                                        renderValue={(selected) => (
                                            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                                {Array.isArray(selected) && selected.map((value) => (
                                                    <Chip key={value} label={value} />
                                                ))}
                                            </Box>
                                        )}
                                        disabled={isDisbursed}
                                    >
                                        {CROP_OPTIONS?.map((crop) => (
                                            <MenuItem key={crop} value={crop}>
                                                {crop}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Box>
                        )}

                        {/* Dynamic Crop Table */}
                        {cropRows?.length > 0 && (
                            <Paper elevation={2} sx={{ mt: 3, overflowX: 'auto' }}>
                                <Typography variant="subtitle1" gutterBottom>
                                    Crop Income Details
                                </Typography>
                                <Table size="small" sx={{ borderCollapse: 'collapse', border: '1px solid black' }}>
                                    <TableHead >
                                        <TableRow sx={{ backgroundColor: 'rgb(207, 226, 243)', border: '1px solid black' }}>
                                            <TableCell sx={{ border: '1px solid black' }}>Crop Name</TableCell>
                                            <TableCell sx={{ border: '1px solid black' }}>Annual Gross Income</TableCell>
                                            <TableCell sx={{ border: '1px solid black' }}>Annual Expense </TableCell>
                                            <TableCell sx={{ border: '1px solid black' }}>Annual Net Income </TableCell>
                                            <TableCell sx={{ border: '1px solid black' }}>Monthly Net Income </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {cropRows?.map((row, index) => (
                                            <TableRow sx={{ border: '1px solid black' }} key={index}>
                                                <TableCell sx={{ border: '1px solid black' }} >{row?.cropName}</TableCell>
                                                <TableCell sx={{ border: '1px solid black' }}>
                                                    <TextField
                                                        type="number"
                                                        size="small"
                                                        value={row?.grossIncome}
                                                        onChange={(e) => handleCropRowChange(index, "grossIncome", e.target.value)}
                                                        inputProps={{ min: 0, style: { width: '100px' } }}
                                                        onKeyDown={(e) => {
                                                            if (e.key === '-' || e.key === 'e') {
                                                                e.preventDefault();
                                                            }
                                                        }}
                                                        disabled={isDisbursed}
                                                    />
                                                </TableCell>
                                                <TableCell sx={{ border: '1px solid black' }}>
                                                    <TextField
                                                        type="number"
                                                        size="small"
                                                        value={row?.expense}
                                                        onChange={(e) => handleCropRowChange(index, "expense", e.target.value)}
                                                        inputProps={{ min: 0, style: { width: '100px' } }}
                                                        onKeyDown={(e) => {
                                                            if (e.key === '-' || e.key === 'e') {
                                                                e.preventDefault();
                                                            }
                                                        }}
                                                        disabled={isDisbursed}
                                                    />
                                                </TableCell>
                                                <TableCell sx={{ border: '1px solid black' }}>{(Number(row?.netIncome) || 0)?.toFixed(2)}</TableCell>
                                                <TableCell sx={{ border: '1px solid black' }}>{(Number(row?.monthlyIncome) || 0)?.toFixed(2)}</TableCell>
                                            </TableRow>
                                        ))}
                                        <TableRow sx={{ backgroundColor: 'rgb(226, 240, 217)' }}>
                                            <TableCell sx={{ border: '1px solid black', fontWeight: 'bold' }}><strong>Total</strong></TableCell>
                                            <TableCell sx={{ border: '1px solid black' }}><strong>{totalGrossIncome?.toFixed(2)}</strong></TableCell>
                                            <TableCell sx={{ border: '1px solid black' }}><strong>{totalExpense?.toFixed(2)}</strong></TableCell>
                                            <TableCell sx={{ border: '1px solid black' }}><strong>{totalNetIncome?.toFixed(2)}</strong></TableCell>
                                            <TableCell sx={{ border: '1px solid black' }}><strong>{totalMonthlyIncome?.toFixed(2)}</strong></TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>

                                <Grid container spacing={2} sx={{ mt: 2 }}>
                                    <Grid item xs={12} md={4} >
                                        <TextField
                                            type="number"
                                            label="Margin (%)"
                                            value={agriculture.margin}
                                            onChange={(e) =>
                                                setAgriculture({ ...agriculture, margin: e.target.value })
                                            }
                                            inputProps={{ min: 0, max: 100 }}
                                            onKeyDown={(e) => {
                                                if (e.key === '-' || e.key === 'e') e.preventDefault();
                                            }}
                                            fullWidth
                                            sx={{ marginTop: '20px' }}
                                            disabled={isDisbursed}
                                        />
                                    </Grid>

                                    <Grid item xs={12} md={4}>
                                        <TextField
                                            type="number"
                                            label="Income consideration per month"
                                            value={((Number(agriculture?.margin) || 0) * totalMonthlyIncome / 100)?.toFixed(2)}
                                            disabled
                                            fullWidth
                                            sx={{ marginTop: '20px' }}
                                        />
                                    </Grid>
                                </Grid>
                            </Paper>
                        )}

                        {/* Legacy Crop Table (keep for backward compatibility if needed) */}
                        {agriculture?.numberOfCrops && cropRows?.length === 0 && (
                            <Paper elevation={2} sx={{ mt: 3, borderRadius: '10px', }}>
                                <Table sx={{ borderCollapse: 'collapse' }} size="small">
                                    <TableHead>
                                        <TableRow sx={{ backgroundColor: 'rgb(207, 226, 243)', border: '1px solid black' }}>
                                            <TableCell sx={{ border: '1px solid black' }} >Crop</TableCell>
                                            <TableCell sx={{ border: '1px solid black' }} >Gross Income</TableCell>
                                            <TableCell sx={{ border: '1px solid black' }}>Expense</TableCell>
                                            <TableCell sx={{ border: '1px solid black' }}>Net Income</TableCell>
                                            <TableCell sx={{ border: '1px solid black' }}>Monthly Net</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {crops?.slice(0, agriculture.numberOfCrops)?.map((crop, index) => (
                                            <TableRow key={index}>
                                                <TableCell sx={{ border: '1px solid black' }} >{crop?.name}</TableCell>
                                                <TableCell sx={{ border: '1px solid black' }} >
                                                    <TextField
                                                        type="number"
                                                        value={crop?.grossIncome}
                                                        onChange={(e) => handleCropChange(index, "grossIncome", e.target.value)}
                                                        inputProps={{ min: 0 }}
                                                        onKeyDown={(e) => {
                                                            if (e.key === '-' || e.key === 'e') {
                                                                e.preventDefault();
                                                            }
                                                        }}
                                                        disabled={isDisbursed}
                                                    />
                                                </TableCell>
                                                <TableCell sx={{ border: '1px solid black' }} >
                                                    <TextField
                                                        type="number"
                                                        value={crop?.expense}
                                                        onChange={(e) => handleCropChange(index, "expense", e.target.value)}
                                                        inputProps={{ min: 0 }}
                                                        onKeyDown={(e) => {
                                                            if (e.key === '-' || e.key === 'e') {
                                                                e.preventDefault();
                                                            }
                                                        }}
                                                        disabled={isDisbursed}
                                                    />
                                                </TableCell>
                                                <TableCell sx={{ border: '1px solid black' }} >{(Number(crop?.netIncome) || 0)?.toFixed(2)}</TableCell>
                                                <TableCell sx={{ border: '1px solid black' }} >{(Number(crop?.monthlyIncome) || 0)?.toFixed(2)}</TableCell>
                                            </TableRow>
                                        ))}
                                        <TableRow sx={{ backgroundColor: "rgb(226, 240, 217)", border: '1px solid black' }}>
                                            <TableCell sx={{ border: '1px solid black' }}><strong>Total</strong></TableCell>
                                            <TableCell sx={{ border: '1px solid black' }}><strong>{totalGross?.toFixed(2)}</strong></TableCell>
                                            <TableCell sx={{ border: '1px solid black' }}><strong>{totalExpenseOld?.toFixed(2)}</strong></TableCell>
                                            <TableCell sx={{ border: '1px solid black' }}><strong>{totalNet?.toFixed(2)}</strong></TableCell>
                                            <TableCell sx={{ border: '1px solid black' }}><strong>{totalMonthly?.toFixed(2)}</strong></TableCell>
                                        </TableRow>
                                        <Grid item xs={12} md={4} sx={{ marginTop: '2rem', display: 'flex', gap: '2rem' }}>
                                            <TextField
                                                type="number"
                                                fullWidth
                                                sx={{ mt: '2rem' }}
                                                label="Margin"
                                                value={agriculture.margin}
                                                onChange={(e) =>
                                                    setAgriculture({ ...agriculture, margin: e.target.value })
                                                }
                                                inputProps={{ min: 0 }}
                                                onKeyDown={(e) => {
                                                    if (e.key === '-' || e.key === 'e') {
                                                        e.preventDefault();
                                                    }
                                                }}
                                                disabled={isDisbursed}
                                            >
                                            </TextField>
                                            <TextField
                                                type="number"
                                                sx={{ mt: '2rem' }}
                                                fullWidth
                                                disabled
                                                label="Income consideration per month"
                                                value={((Number(agriculture?.margin) || 0) * (Number(totalMonthly) || 0))?.toFixed(2)}
                                            >
                                            </TextField>
                                        </Grid>

                                    </TableBody>
                                </Table>
                            </Paper>
                        )}
                    </>
                )}


                {addSecondary && (
                    <Box mt={3}>
                        <Button
                            sx={{ backgroundColor: '#034c9b' }}
                            variant="contained"
                            color="primary"
                            onClick={handleAddData}
                            disabled={!secondaryIncomeDetails?.incomeType || isDisbursed}
                        >
                            {updateandSubmitbtn}
                        </Button>
                    </Box>
                )}
            </Paper>
            <h3 style={{ fontWeight: 'bold', textAlign: 'center', fontSize: '1.2rem', margin: '10px' }}>
                Salary/Business Income
            </h3>
            {/* Existing Secondary Income Table */}
            {(rows?.filter((val) => (val?.incomeType === "Salary" || val?.incomeType === "Business" || val?.incomeType?.includes("Business"))))?.length > 0 && (
                <Paper elevation={3} sx={{ p: 2, overflowX: 'auto', overflowY: 'visible'}}>
                    <Typography variant="h6" gutterBottom>
                        
                    </Typography>
                    <Table sx={{ borderCollapse: 'collapse', mb: 1, minWidth: '1000px', width: '100%',tableLayout: 'fixed' }}>
                        <TableHead>
                            <TableRow sx={{ backgroundColor: 'rgb(207, 226, 243)' }}>
                                <TableCell sx={{ border: '1px solid black', fontWeight: 'bold' }}>Name</TableCell>
                                <TableCell sx={{ border: '1px solid black', fontWeight: 'bold' }}>Relationship</TableCell>
                                <TableCell sx={{ border: '1px solid black', fontWeight: 'bold' }}>Income Type</TableCell>
                                <TableCell sx={{ border: '1px solid black', fontWeight: 'bold' }}>Amount</TableCell>
                                <TableCell sx={{ border: '1px solid black', fontWeight: 'bold' }}>Source</TableCell>
                                <TableCell sx={{ border: '1px solid black', fontWeight: 'bold' }}>Margin</TableCell>
                                <TableCell sx={{ border: '1px solid black', fontWeight: 'bold' }}>Mode</TableCell>
                                <TableCell sx={{ border: '1px solid black', fontWeight: 'bold' }}>Final Income</TableCell>
                                {(deleteSecondary || editSecondary || visible) && (
                                    <TableCell sx={{ border: '1px solid black', fontWeight: 'bold' }}>
                                        Action
                                    </TableCell>
                                )}
                            </TableRow>
                        </TableHead>

                        <TableBody>
                            {(rows?.filter((val) => (val?.incomeType === "Salary" || val?.incomeType === "Business" || val?.incomeType?.includes("Business")))).length > 0 && (rows?.filter((val) => (val?.incomeType === "Salary" || val?.incomeType === "Business" || val?.incomeType?.includes("Business"))))?.map((row) => (
                                <TableRow key={row._id}>
                                    <TableCell sx={{ border: '1px solid black' }}>{row?.earningMemeberName}</TableCell>
                                    <TableCell sx={{ border: '1px solid black' }}>{row?.relationshipWithApplicant}</TableCell>
                                    <TableCell sx={{ border: '1px solid black' }}>{row?.incomeType}</TableCell>
                                    <TableCell sx={{ border: '1px solid black' }}>{row?.amount}</TableCell>
                                    <TableCell sx={{ border: '1px solid black' }}>{row?.incomeSource}</TableCell>
                                    <TableCell sx={{ border: '1px solid black' }}>{row?.margin}</TableCell>
                                    <TableCell sx={{ border: '1px solid black' }}>{row?.incomeMode}</TableCell>
                                    <TableCell sx={{ border: '1px solid black' }}>{row?.finalIncome}</TableCell>
                                    {(deleteSecondary || editSecondary || visible) && (
                                        <TableCell sx={{ border: '1px solid black' }}>
                                            {(deleteSecondary || visible )&& (
                                                <DeleteIcon
                                                    sx={{ cursor: isDisbursed ? 'not-allowed' : 'pointer', color: 'red' }}
                                                    onClick={() => !isDisbursed && deleteSecondaryIncome(row?._id || row?.id)}
                                                />
                                            )}

                                            {(editSecondary || visible) && (
                                                <EditIcon
                                                    sx={{
                                                        cursor: isDisbursed ? 'not-allowed' : 'pointer',
                                                        color: '#034c9b',
                                                        ml: deleteSecondary ? '8px' : 0,
                                                    }}
                                                    onClick={() => !isDisbursed && handleUpdateData(row)}
                                                />
                                            )}
                                        </TableCell>
                                    )}
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </Paper>
            )}
            {/* Existing Agriculture Income Table */}
            {rows?.filter((val) => val?.incomeType === "Agriculture")?.length > 0 && (
                <Paper elevation={3} sx={{ p: 2, overflowX: 'auto', overflowY: 'visible'}}>
                    <h3 style={{ fontWeight: 'bold', textAlign: 'center', fontSize: '1.2rem', margin: '10px' }}>
                        Agriculture Income
                    </h3>

                    {rows?.filter((val) => val?.incomeType === "Agriculture")?.map((row) => (
                        <Box key={row?._id} sx={{ mb: 4, overflowX: 'auto', overflowY: 'visible' }}>
                            {/* Main Agriculture Details Table */}
                            <Table sx={{ borderCollapse: 'collapse', mb: 1, minWidth: '1000px', width: '100%',tableLayout: 'fixed' }}>
                                <TableHead>
                                    <TableRow sx={{ backgroundColor: 'rgb(207, 226, 243)' }}>
                                        <TableCell sx={{ border: '1px solid black', fontWeight: 'bold', width: '12.5%' }}>Name</TableCell>
                                        <TableCell sx={{ border: '1px solid black', fontWeight: 'bold', width: '12.5%' }}>Relationship</TableCell>
                                        <TableCell sx={{ border: '1px solid black', fontWeight: 'bold', width: '12.5%' }}>Income Type</TableCell>
                                        <TableCell sx={{ border: '1px solid black', fontWeight: 'bold', width: '12.5%' }}>Amount</TableCell>
                                        <TableCell sx={{ border: '1px solid black', fontWeight: 'bold', width: '12.5%' }}>Source</TableCell>
                                        <TableCell sx={{ border: '1px solid black', fontWeight: 'bold', width: '12.5%' }}>Margin</TableCell>
                                        <TableCell sx={{ border: '1px solid black', fontWeight: 'bold', width: '12.5%' }}>Mode</TableCell>
                                        <TableCell sx={{ border: '1px solid black', fontWeight: 'bold', width: '12.5%' }}>Final Income / Month</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    <TableRow>
                                        <TableCell sx={{ border: '1px solid black', width: '12.5%' }}>{row?.earningMemeberName || ""}</TableCell>
                                        <TableCell sx={{ border: '1px solid black', width: '12.5%' }}>{row?.relationshipWithApplicant || ""}</TableCell>
                                        <TableCell sx={{ border: '1px solid black', width: '12.5%' }}>{row?.incomeType || ""}</TableCell>
                                        <TableCell sx={{ border: '1px solid black', width: '12.5%' }}>{row.amount || ""}</TableCell>
                                        <TableCell sx={{ border: '1px solid black', width: '12.5%' }}>{row?.incomeSource || ""}</TableCell>
                                        <TableCell sx={{ border: '1px solid black', width: '12.5%' }}>{row.margin}</TableCell>
                                        <TableCell sx={{ border: '1px solid black', width: '12.5%' }}>{row?.incomeMode || ""}</TableCell>
                                        <TableCell sx={{ border: '1px solid black', width: '12.5%' }}>{row?.finalIncome}</TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>

                            {/* Agriculture Land Details Table */}
                            <Table sx={{ borderCollapse: 'collapse', mt: 2, minWidth: '1000px', width: '100%',tableLayout: 'fixed' }}>
                                <TableHead>
                                    <TableRow sx={{ backgroundColor: 'rgb(207, 226, 243)' }}>
                                        <TableCell sx={{ border: '1px solid black', fontWeight: 'bold', width: '12.5%' }}>Owned Land</TableCell>
                                        <TableCell sx={{ border: '1px solid black', fontWeight: 'bold', width: '12.5%' }}>Total Land Holders</TableCell>
                                        <TableCell sx={{ border: '1px solid black', fontWeight: 'bold', width: '12.5%' }}>Borrower Owned Land</TableCell>
                                        <TableCell sx={{ border: '1px solid black', fontWeight: 'bold', width: '12.5%' }}>Rented Land</TableCell>
                                        <TableCell sx={{ border: '1px solid black', fontWeight: 'bold', width: '12.5%' }}>Cultivation Land</TableCell>
                                        <TableCell sx={{ border: '1px solid black', fontWeight: 'bold', width: '12.5%' }}>Irrigation Status</TableCell>
                                        <TableCell sx={{ border: '1px solid black', fontWeight: 'bold', width: '12.5%' }}>No of Crops / Year</TableCell>
                                        <TableCell sx={{ border: '1px solid black', fontWeight: 'bold', width: '12.5%' }}>Actions / View Crops</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    <TableRow>
                                        <TableCell sx={{ border: '1px solid black', width: '12.5%' }}>{row?.ownedLand || ""}</TableCell>
                                        <TableCell sx={{ border: '1px solid black', width: '12.5%' }}>{row?.totalLandHolders || ""}</TableCell>
                                        <TableCell sx={{ border: '1px solid black', width: '12.5%' }}>{row?.borrowerOwnedLand || ""}</TableCell>
                                        <TableCell sx={{ border: '1px solid black', width: '12.5%' }}>{row?.rentedLand || ""}</TableCell>
                                        <TableCell sx={{ border: '1px solid black', width: '12.5%' }}>{row?.cultivationLand || ""}</TableCell>
                                        <TableCell sx={{ border: '1px solid black', width: '12.5%' }}>{row?.irrigationStatus || ""}</TableCell>
                                        <TableCell sx={{ border: '1px solid black', width: '12.5%' }}>{row?.numberOfCrops || ""}</TableCell>
                                        <TableCell sx={{ border: '1px solid black', width: '12.5%', textAlign: 'center' }}>
                                            <Tooltip title="Delete">
                                                <DeleteIcon
                                                    sx={{ cursor: "pointer", color: "red" }}
                                                    onClick={() => deleteSecondaryIncome(row?._id || row?.id)}
                                                    disabled={isDisbursed}
                                                />
                                            </Tooltip>
                                            <Tooltip title="Edit">
                                                <EditIcon
                                                    sx={{ cursor: "pointer", color: '#034c9b', ml: '8px' }}
                                                    onClick={() => handleUpdateData(row)}
                                                    disabled={isDisbursed}
                                                />
                                            </Tooltip>
                                            <Tooltip title="View Crops">
                                                <VisibilityIcon sx={{ cursor: "pointer", color: '#034c9b', ml: '8px' }} onClick={() => handleOpenModal(row)} ></VisibilityIcon>
                                            </Tooltip>

                                        </TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </Box>
                    ))}
                </Paper>
            )}
            <CropsModal
                open={modalOpen}
                onClose={handleCloseModal}
                row={selectedRow}
            />
            <ToastContainer />
            <Backdrop sx={{ color: "#fff", zIndex: 1200 }} open={open}>
                <CircularProgress color="inherit" />
            </Backdrop>
        </Box>
    );
};

export default SecondaryIncome;